import React, { Component } from "react";

import {
  CBadge,
  CCard,
  CCardBody,
  CButton,
  CFormGroup,
  CLabel
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./style.css";

const isImage = file => {
  const lower = file.toLowerCase();
  return (
    file &&
    (lower.endsWith("jpg") ||
      lower.endsWith("png") ||
      lower.endsWith("jpeg") ||
      lower.endsWith("gif") ||
      lower.endsWith("bmp") ||
      lower.endsWith("svg") ||
      lower.endsWith("tiff") ||
      lower.endsWith("webp"))
  );
};

class NotificationDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      selectedRoles: [],
      title: "",
      description: "",
      file: null,
      name: null,
      ciente: null
    };

    this.atualizar = this.atualizar.bind(this);
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.match.params;
    axios
      .get(`${URL.api}access/role/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respRole => {
          let rolesAux = [];
          let idAux = 9;
          for (let i = 0; i < this.props.user.user_roles.length; i++) {
            if (this.props.user.user_roles[i].role_id < idAux) {
              idAux = this.props.user.user_roles[i].role_id;
            }
          }
          respRole.data.data.map(item => {
            if (item.id > idAux) {
              rolesAux.push({
                value: item.id,
                label: item.name,
                type: item.type
              });
            }
          });

          this.setState({}, () => {
            if (!id) {
              this.setState({ loading: false });
            } else {
              axios
                .get(`${URL.api}communication/notice/singleView/${id}`, {
                  headers: {
                    authorization: `Bearer ${this.props.user.token}`
                  }
                })
                .then(
                  resp => {
                    let EstouCiente = false;

                    resp.data.data.aware.map(ciente => {
                      if (ciente.user_id === this.props.user.user.id)
                        EstouCiente = true;
                    });

                    const InicioString =
                      // eslint-disable-next-line prefer-template
                      URL.public + "uploads/activity/";
                    this.setState(
                      {
                        ciente: EstouCiente,
                        title: resp.data.data.title,
                        file: resp.data.data?.uploads[0]?.file || null,
                        name:
                          resp.data.data.uploads[0]?.file.replace(
                            InicioString,
                            ""
                          ) || null,
                        description: JSON.stringify(resp.data.data.description)
                          ?.text,
                        selectedRoles: resp.data.data.roles.map(item => ({
                          role_id: item.role_id,
                          group_id: item.group_id,
                          region_id: item.region_id,
                          school_id: item.school_id,
                          room_id: item.room_id,
                          student_id: null,
                          role_type: respRole.data.data.find(
                            role => role.id === item.role_id
                          ).type
                        }))
                      },
                      () => {
                        this.setState({
                          // edit: true,
                          loading: false
                        });
                      }
                    );
                  },
                  error => {
                    this.error(error.response.statusText);
                  }
                );
            }
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    // Atualizar lista de Turma
    axios
      .get(
        `${URL.api}community/room/list?class=true&school[]=${this.props.general.active_roles.school_id}`,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(resp => {
        if (resp.data.success) {
          // Atualize o estado com a lista de turmas, se necessário
        }
      });
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  validator(validator) {
    for (let i = 0; i < validator.length; i++) {
      if (!validator[i].value) {
        toastr.error("Erro", `Favor preencher o campo ${validator[i].label}`);
        return false;
      }
    }

    return true;
  }

  atualizar() {
    const role = this.state.selectedRoles.map((item, index) => ({
      role_id: item.role_id,
      group_id: ["U", "R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.group_id
        : null,
      region_id: ["R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.region_id
        : null,
      school_id: ["E", "P", "A", "S"].includes(item.role_type)
        ? item.school_id
        : null,
      room_id: item.room_id,
      student_id: item.student_id
    }));

    const obj = {
      title: this.state.title,
      description: this.state.description,
      roles: role
    };

    const { id } = this.props.match.params;

    axios
      .post(`${URL.api}communication/notice/update/${id}`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.history.push("/notice/list");
      });
  }

  AdicionarAnexo() {}

  EstouCiente() {
    const { id } = this.props.match.params;

    const obj = {
      notice_id: id,
      aware: true
    };
    axios
      .post(`${URL.api}communication/notice/markAware`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.componentDidMount();
      });
  }

  getDescription(description) {
    try {
      let result = JSON.parse(description)[0].children[0].text;
      return result;
    } catch {
      return description;
    }
  }

  render() {
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/notice/me", to: "/notice/me" }]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <CCard>
            <CCardBody>
              <CFormGroup>
                <CLabel className="titulo d-block">Título</CLabel>
                <CLabel>{this.state.title}</CLabel>
              </CFormGroup>
              {this.state.description && (
                <CFormGroup>
                  <CLabel className="titulo d-block">Descrição</CLabel>
                  <CLabel>{this.getDescription(this.state.description)}</CLabel>
                </CFormGroup>
              )}
              <CFormGroup>
                {this.state.file && (
                  <>
                    <CLabel className="titulo d-block">Anexo</CLabel>{" "}
                    {isImage(this.state.file) ? (
                      <img
                        src={this.state.file}
                        alt="Anexo"
                        className="rounded-lg cursor"
                        onClick={() => window.open(this.state.file, "_blank")}
                        style={{ height: "100px" }}
                      />
                    ) : (
                      <CBadge
                        color="light"
                        className="mfe-2 p-2 cursor btn-light"
                        onClick={() => window.open(this.state.file, "_blank")}
                      >
                        <i className="fa fa-file mr-2"></i>
                        {this.state.name}
                      </CBadge>
                    )}
                  </>
                )}
              </CFormGroup>{" "}
              <div className="x">
                {this.state.ciente && (
                  <CButton color="dark" className="ciente" disabled="true">
                    Estou Ciente <i className="fa fa-thumbs-o-up"></i>
                  </CButton>
                )}
                {!this.state.ciente && (
                  <CButton
                    color="success"
                    className="ciente"
                    onClick={() => this.EstouCiente()}
                  >
                    Estou Ciente
                  </CButton>
                )}
              </div>
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationDetail);
